import { IProduct, IProductLevel2, IProductLevel3 } from '@engyalo/storefront-types/lib/plugins/model'

export const generateCartId = (product: IProduct): string => {
    let cartId = ''

    const { id, customizations } = product

    if (id) {
        cartId += id
    }

    if (customizations) {
        customizations.forEach((level2: IProductLevel2 | null) => {
            if (level2) {
                const { id, customizations: level2Customizations } = level2

                if (id) {
                    cartId += `_${id}`
                }

                if (level2Customizations) {
                    level2Customizations.forEach((level3: IProductLevel3 | null) => {
                        if (level3) {
                            const { id } = level3

                            if (id) {
                                cartId += `-${id}`
                            }
                        }
                    })
                }
            }
        })
    }

    return cartId
}
